// cookie
import { cookie } from 'qiao.cookie.js';
import { getCookie, setCookie } from 'cookies-next';
import { constants } from './_constants.js';

export { deleteCookie, getCookie, setCookie } from 'cookies-next';
/**
 * @description 全局设备唯一标识
 */
export const WEBID_COOKIE_KEY = 'webid';
export const createRandomId = () => {
  const abc = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'g',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
  ];
  const [max, min] = [Math.floor(Math.random() * (10 - 7 + 1) + 1), Math.floor(Math.random() * (17 - 10 + 1) + 17)];
  const suffix = abc
    .sort(() => 0.4 - Math.random())
    .slice(max, min)
    .slice(0, 8)
    .join('');
  const localId = new Date().getTime() + suffix;
  return localId;
};

export const setCookieLongTerm = (key, data, options = {}) => {
  setCookie(key, data, { ...options, maxAge: 60 * 60 * 24 * 365 * 10 });
};

export const setCookieSession = (key, data, options) => {
  setCookie(key, data, { ...options });
};

export const getCookieWebid = (options) => {
  const webid = getCookie(WEBID_COOKIE_KEY, options);

  if (!webid || typeof webid !== 'string') {
    const randomId = createRandomId();
    setCookieLongTerm(WEBID_COOKIE_KEY, randomId, options);
    return randomId;
  }

  return webid;
};

/**
 * getWebIdFromCookie
 * @returns
 */
export const getWebIdFromCookie = () => {
  const webid = cookie(constants.webid) || cookie(constants.old_webid);
  return webid;
};

/**
 * setWebIdToCookie
 * @param {*} webid
 * @returns
 */
export const setWebIdToCookie = (webid) => {
  return cookie(constants.usertoken, webid);
};

/**
 * getUsertokenFromCookie
 * @returns
 */
export const getUsertokenFromCookie = () => {
  const usertoken = cookie(constants.usertoken) || cookie(constants.old_usertoken);
  return usertoken;
};

/**
 * setUsertokenToCookie
 * @param {*} usertoken
 * @returns
 */
export const setUsertokenToCookie = (usertoken) => {
  return cookie(constants.usertoken);
};

/**
 * 删除cookie. 此前cookie函数不生效
 * @param {*} cookieName
 */
export const clearCookie = (cookieName) => {
  document.cookie = encodeURIComponent(cookieName) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
};

/**
 * clearUsertokenToCookie
 * @returns
 */
export const clearUsertokenToCookie = () => {
  cookie(constants.usertoken, null);
  cookie(constants.old_usertoken, null);

  clearCookie(constants.usertoken);
  clearCookie(constants.old_usertoken);
  if (typeof window !== 'undefined') {
    window.localStorage.setItem('__userinfo_token__', null);
  }
};
